import { api } from './api';

export async function destroy<T>(url: string): Promise<T> {
  return api<T>(url, { method: 'delete' });
}
